import { useTranslations } from '@/hooks/useTranslations';
import { sanitizeMessage } from './messageSanitizer';

export const dbMessagesMap: Record<string, string> = {
  'Email already exists': 'email_exists',
  'Password is invalid': 'invalid_password',
  'Bad request, email or tenantId is missing': 'missing_email_or_tenant',
  'Access is restricted, please contact info@tenxerlabs.com':
    'access_restricted',
  'User not found, Signup to proceed.': 'user_not_found_signup',
  'Email not signed up with this tenant!': 'email_not_in_tenant',
  'You are not eligible for login or signup': 'not_eligible',
  'You signed by external auth.': 'external_auth_user',
  'User not found': 'user_not_found',
  'This user does not enable password yet': 'password_not_enabled',
  'We have sent a reset password link to your email.':
    'reset_password_link_sent',
  'Failed to reset password link': 'reset_password_link_failed',
  'Failed to send reset password link. Please try again later.':
    'reset_password_link_failed_try_again',
  'Invalid or expired token': 'invalid_expired_token',
  'Password successfully updated!': 'password_updated',
  'Failed to reset password. Please try again later.':
    'reset_password_failed_try_again',
  'Login successful': 'login_successful',
  'Password is incorrect': 'incorrect_password',
  'Failed to login': 'login_failed',
  'User logged out successfully!': 'logout_successful',
  'Failed to logout user': 'logout_failed',
  'Password set successfully': 'password_set_success',
  'Email updated successfully': 'email_updated',
  'please, do signup first': 'signup_first',
  'Secondary user created!': 'secondary_user_created',
  'Office email required': 'office_email_required',
  'User already exists with this tenant': 'user_exists_in_tenant',
  'User created successfully': 'user_created',
  'An error occurred while creating the user': 'user_creation_error',
  'User does not exist': 'user_does_not_exist',
  'Invalid login data': 'invalid_login_data',
  'No active session found for the provided client ID': 'no_active_session',
  'Authorization token is missing': 'missing_auth_token',
  'Invalid authorization token format': 'invalid_auth_token_format',
  'Invalid or expired authorization token': 'invalid_expired_auth_token',
  'You have assigned this permission': 'permission_assigned',
  'You have not assigned this permission': 'permission_not_assigned',
  'Token is missing or incorrectly formatted': 'token_missing_or_incorrect',
  'Token is missing': 'token_missing',
  'Token is valid': 'token_valid',
  'Token is not valid': 'token_invalid',
  'Internal server error': 'internal_server_error',
  'Tenant id or name is missing': 'missing_tenant_info',
  'Invalid tenant': 'invalid_tenant',
  'Invalid signature': 'invalid_signature',
  'User ID not found in token': 'user_id_not_found',
  'Tenant details not provided': 'tenant_details_missing',
  'Access token not provided': 'access_token_missing',
  'You are not authorized for this tenant.': 'unauthorized_tenant',
  'Unauthorized access': 'unauthorized_access',
  'Email is blocked.': 'email_blocked',
  'OTP sent successfully': 'otp_sent_successfully',
  'Invalid OTP': 'invalid_otp',
  'OTP Verified, User created': 'otp_verified_user_created',
  'OTP Verified': 'otp_verified',
};

export const useGetErrorMessage = () => {
  const { translations: dbMessages } = useTranslations('dbMessages');

  const getDBMessage = (error: string) => {
    if (!error) return '';
    const messageKey = dbMessagesMap[error];
    const message = messageKey ? dbMessages[messageKey] || error : error;
    // Sanitize message to remove any emojis from backend responses
    return sanitizeMessage(message);
  };

  return {
    getDBMessage,
  };
};
